import { Outlet, createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/_authed/_admin/guild-events/schedules")({
  component: Outlet,
})
